module.exports = __webpack_public_path__ + "/content/shared/img/lambo/lamborghini-notification-header-image.png";